export default "__VITE_ASSET__A_FxyFDX__"